import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  Modal,
  TextField,
} from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  // addAnalysisAndGraphs,
  // setAnalysisGraphs,
  setIsLoading,
} from "../../../features/datatable/dataTableSlice";

import {
  getStringValues,
  createAnalysis,
  getHeaders,
} from "../../../utils/computation/analysis";
import { getColumnValues } from "../../../utils/computation/getColumnValues";
import { getSinglePriceTimeSeries } from "../../../utils/computation/getSinglePriceTimeSeries";
import Dropdown from "../../Dropdown";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  bgcolor: "background.paper",
  p: 4,
  borderRadius: "15px",
};

const TimeSeriesModal = ({ title, closeMenu, openModal, setOpenModal }) => {
  //local states
  const [Year, setYear] = useState("");
  const [Month, setMonth] = useState("");
  const [newTitle, setnewTitle] = useState("");

  //redux states
  const { token } = useSelector((state) => state.auth);
  const { data } = useSelector((state) => state.dataTable);

  //dispatch
  const dispatch = useDispatch();

  //params
  const { documentId } = useParams();

  //functions
  const handleChangeYear = (event) => {
    setYear(event.target.value);
  };
  const handleChangeMonth = (event) => {
    setMonth(event.target.value);
  };
  const handleCloseModal = () => {
    closeMenu();
    setOpenModal(false);
  };
  const createGraph = async () => {
    dispatch(setIsLoading());
    // get the array value of selected column
    const y = getStringValues(data, Month);
    const x = getColumnValues(data, Year);
    const xHeader = getHeaders(data, Year);
    const yHeader = getHeaders(data, Month);

    closeMenu();

    if (y.length > 0 && x.length > 0) {
      let graphResult = await getSinglePriceTimeSeries({
        dates: y,
        arr: x,
        xlabel: xHeader[0],
        ylabel: yHeader[0],
        title: newTitle,
      });
      //populate analysis object
      const graphs = {
        ...graphResult,
        column: Year + ", " + Month,
        x: Year,
        y: Month,
        firstColumn: Year,
        secondColumn: Month,
        title,
      };
      try {
        // create analysis in subcollection
        const resFromCreateAnalysis = await createAnalysis(
          token,
          documentId,
          graphs
        );
        graphs.id = resFromCreateAnalysis.id;
      } catch (error) {
        return console.log("error", error);
      }
      // dispatch(addAnalysisAndGraphs(graphs));
    } else {
    }
    dispatch(setIsLoading());
  };

  return (
    <Modal
      open={openModal === title}
      onClose={handleCloseModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <h1> {title}</h1>
        <Grid item xs={6} p={1}>
          <h3> Data Range</h3>
          <h3
            style={{
              marginTop: "10px",
            }}
          >
            Select a column
          </h3>
          <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
            <InputLabel id="demo-simple-select-label">
              Select a column
            </InputLabel>
            <Dropdown value={Year} onChange={handleChangeYear} />
          </FormControl>
        </Grid>
        <Grid item xs={6} p={1}>
          <h3
            style={{
              marginTop: "10px",
            }}
          >
            Dates
          </h3>
          <FormControl variant="filled" fullWidth sx={{ mt: 1 }}>
            <InputLabel id="demo-simple-select-label">
              Select a column
            </InputLabel>
            <Dropdown value={Month} onChange={handleChangeMonth} />
          </FormControl>
          <h3
            style={{
              marginTop: "10px",
            }}
          >
            Title
          </h3>
          <TextField
            fullWidth
            id="filled-basic"
            variant="filled"
            label="Title"
            sx={{ mt: 1 }}
            onChange={(e) => setnewTitle(e.target.value)}
          />
        </Grid>
        <div style={{ display: "flex", float: "right", marginTop: "20px" }}>
          <Button
            variant="outlined"
            style={{
              borderRadius: "7px",
            }}
            onClick={handleCloseModal}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            style={{
              width: "auto",
              marginLeft: "10px",
              borderRadius: "7px",
            }}
            onClick={() => createGraph()}
          >
            Run Function
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default TimeSeriesModal;
